const genClassName = ({
	base = "",
	conditionals = {}, // {"condition-class-name-like-this": boolean indicating presence}
	additional = "",
} = {}) => {
	let className = base;

	const conditionalArray = Object.entries(conditionals);
	conditionalArray.forEach(([conditionalClass, condition]) => {
		if (!!condition) {
			className = `${className} ${conditionalClass}`;
		}
	});

	if (additional) {
		className = `${className} ${additional}`;
	}

	return className;
};
export default genClassName;
